import React from 'react';

/**
 * PremiumTrackingModal - $4.99 Premium Tracking upsell modal
 * Shows when user can benefit from Premium Tracking features
 */
const PremiumTrackingModal = ({
  show,
  onClose,
  onSubscribe
}) => {
  if (!show) return null;
  
  return (
    <div 
      className="modal-overlay" 
      style={{ zIndex: 10000 }}
      onClick={onClose}
    >
      <div 
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '380px',
          width: '90%',
          background: 'var(--bg-card)',
          borderRadius: '20px',
          padding: '28px 24px',
          margin: '20px auto',
          maxHeight: '90vh',
          overflow: 'auto',
          position: 'relative'
        }}
      >
        {/* Close Button */}
        <button 
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'rgba(255,255,255,0.1)',
            border: 'none',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            cursor: 'pointer',
            fontSize: '18px',
            color: 'var(--text-secondary)'
          }}
        >
          ×
        </button>
        
        {/* Icon */}
        <div style={{ textAlign: 'center', marginBottom: '16px' }}>
          <div style={{ 
            fontSize: '48px', 
            marginBottom: '8px',
            background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)',
            borderRadius: '50%',
            width: '80px',
            height: '80px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px auto'
          }}>
            📊
          </div>
          
          {/* Title */}
          <h2 style={{ 
            fontSize: '22px', 
            fontWeight: '700', 
            marginBottom: '12px',
            color: 'var(--text-primary)'
          }}>
            Premium Tracking
          </h2>
          
          {/* Price */}
          <div style={{ marginBottom: '20px' }}>
            <span style={{ 
              fontSize: '36px', 
              fontWeight: '800', 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              $4.99
            </span>
            <span style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>/month</span>
          </div>
        </div>
        
        {/* Features */}
        <div style={{ 
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '20px'
        }}>
          <ul style={{ 
            margin: 0, 
            padding: '0 0 0 20px', 
            fontSize: '14px',
            lineHeight: '2'
          }}>
            <li>📷 <strong>Barcode Scanner</strong> - Instant food logging</li>
            <li>🍽️ <strong>Restaurant Search</strong> - Menu items database</li>
            <li>💊 <strong>Micronutrients</strong> - Vitamins & minerals tracking</li>
            <li>📈 <strong>Improves MIQ</strong> - More data = smarter AI</li>
          </ul>
        </div>
        
        {/* CTA */}
        <button 
          onClick={onSubscribe}
          className="btn-primary"
          style={{ 
            width: '100%', 
            padding: '14px',
            fontSize: '16px',
            fontWeight: '600',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            marginBottom: '12px'
          }}
        >
          Start Premium Tracking
        </button>
        
        {/* Footer */}
        <p style={{ 
          textAlign: 'center',
          fontSize: '12px',
          color: 'var(--text-secondary)',
          margin: '8px 0 0 0',
          fontWeight: '500'
        }}>
          $4.99/month · Improves MIQ accuracy
        </p>
      </div>
    </div>
  );
};

export default PremiumTrackingModal;
